export const QUICK_ACTION_ID = 'GUIDDE-JS-QuickAction'

export const QUICK_ACTION_POPUP_ID = 'QUICK_ACTION_POPUP_ID'
export const QUICK_ACTION_SHADOW_ID = 'QUICK_ACTION_SHADOW_ID'
export const CAPTURE_GUIDDE_ID = 'GUIDDE-JS-QA-Capture'
export const INSERT_LAST_GUIDDE_ID = 'GUIDDE-JS-QA-InsertLast'
export const SEARCH_GUIDDE_ID = 'GUIDDE-JS-QA-Search'
